module.exports = __webpack_public_path__ + "img/5.26b8cc98.jpg";